import { render, staticRenderFns } from "./ConsentView.vue?vue&type=template&id=2e42cf2c"
import script from "./ConsentView.vue?vue&type=script&lang=js"
export * from "./ConsentView.vue?vue&type=script&lang=js"
import style0 from "./ConsentView.vue?vue&type=style&index=0&id=2e42cf2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports